import React, {useState} from 'react';
import {Button, PopOver} from "@dts-soldel/dts-react-common";
import Icon from "../../../misc/Icon";
import PropTypes from "prop-types";
import popOverMode from "@dts-soldel/dts-react-common/components/pop-over/PopOverMode";

const propTypes = {
	popOverText: PropTypes.shape({
		helpText: PropTypes.string.isRequired,
		defaultValue: PropTypes.any,
	}).isRequired,

	// example field/value is because most everything that calls this uses configuratorStore.setFieldValue
	// which takes a field and a value, so can just pass straight through to this field/func for simplicity
	onUseExampleField: PropTypes.string,
	onUseExampleFieldValue: PropTypes.func,

	// anything that doesn't use configuratorStore.setFieldValue can use onUseExampleValue to custom handle
	// the example value
	onUseExampleValue: PropTypes.func,
};
const defaultProps = {
	onUseExampleField: undefined,
	onUseExampleFieldValue: undefined,
	onUseExampleValue: undefined,
};

const HelpIcon = ({popOverText: {helpText, exampleValue}, onUseExampleField, onUseExampleFieldValue, onUseExampleValue}) => {
	if (!!onUseExampleFieldValue && !!onUseExampleValue) {
		console.error('HelpIcon: Should have one or the other but not both.', {exampleValue, onUseExampleValue, onUseExampleField, helpText});
	}

	if (!!onUseExampleField !== !!onUseExampleFieldValue) {
		console.error('HelpIcon: onUseExampleField and onUseExampleFieldValue mismatch. Should have both or none.', {onUseExampleField, onUseExampleFieldValue, helpText});
	}

	if (exampleValue && !onUseExampleFieldValue && !onUseExampleValue) {
		console.error('HelpIcon: exampleValue provided, but no callback for its use', {onUseExampleField, onUseExampleFieldValue, onUseExampleValue, helpText});
	}

	const [isPopOverOpen, setIsPopOverOpen] = useState(false);

	return (
		<PopOver
			anchor={Icon.iconInfo()}
			position={PopOver.POSITION.TOP}
			className={'help-icon'}
			dismissible={true}
			mode={popOverMode.CLICK}
			onPopoverToggle={() => setIsPopOverOpen(isOpen => !isOpen)}
			showPopup={isPopOverOpen}
		>
			{helpText}
			{
				exampleValue ? (
					<div className="help-icon--example-button-wrapper">
						<Button
							label="Use Example Value"
							onClick={
								() => {
									setIsPopOverOpen(false);
									onUseExampleValue && onUseExampleValue(exampleValue);
									onUseExampleFieldValue && onUseExampleFieldValue(onUseExampleField, exampleValue);
								}
							}
							setInitialFocus={true}
						/>
					</div>
				) : undefined
			}
		</PopOver>
	);
};

HelpIcon.propTypes = propTypes;
HelpIcon.defaultProps = defaultProps;

export default HelpIcon;
